import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-settings-main',
  templateUrl: './settings-main.component.html',
  styleUrls: ['./settings-main.component.less'],
  standalone: false,
})
export class SettingsMainComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
